import { render } from "./manageEdit.vue?vue&type=template&id=1ba7fac5&scoped=true"
import script from "./manageEdit.vue?vue&type=script&lang=js"
export * from "./manageEdit.vue?vue&type=script&lang=js"

import "./manageEdit.vue?vue&type=style&index=0&id=1ba7fac5&lang=scss&scoped=true"
import "./manageEdit.vue?vue&type=style&index=1&id=1ba7fac5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba7fac5"]])

export default __exports__